<template>
    <div class="section">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li><router-link to="/admin">Admin Settings</router-link></li>
          <li class="is-active"><router-link to="/admin/admin-activity-logs" aria-current="true">Admin Logs</router-link></li>
        </ul>
      </nav>
      <div class="container">
        <h1 class="title">Admin Logs</h1>
        
        <!-- Filters -->
        <div class="field is-grouped mt-3">
          <div class="control">
            <input v-model="filters.start_date" class="input is-small" type="date" placeholder="Start Date">
          </div>
          <div class="control">
            <input v-model="filters.end_date" class="input is-small" type="date" placeholder="End Date">
          </div>
          <div class="control">
            <select v-model="filters.action" class="input is-small">
              <option value="">All Actions</option>
              <option value="GET">GET</option>
              <option value="POST">POST</option>
              <option value="PUT">PUT</option>
              <option value="DELETE">DELETE</option>
            </select>
          </div>
          <div class="control">
            <input v-model="filters.user" class="input is-small" type="text" placeholder="User">
          </div>
          <div class="control">
            <button class="button is-primary is-small" @click="applyFilters">Apply Filters</button>
          </div>
          <div class="control">
            <button class="button is-warning is-small" @click="resetFilters">Reset Filters</button>
          </div>
          <div class="control">
            <button class="button is-success is-small" @click="downloadCSV">Download CSV</button>
          </div>
        </div>
  
        <!-- Logs Table -->
        <table class="table is-fullwidth is-small mt-5">
          <thead>
            <tr>
              <th class="is-size-7">User</th>
              <th class="is-size-7">Action</th>
              <th class="is-size-7">Endpoint</th>
              <th class="is-size-7">IP Address</th>
              <th class="is-size-7">Timestamp</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in logs" :key="log.id">
              <td class="is-size-7">{{ log.user }}</td>
              <td class="is-size-7">{{ log.action }}</td>
              <td class="is-size-7">{{ log.endpoint }}</td>
              <td class="is-size-7">{{ log.ip_address }}</td>
              <td class="is-size-7">{{ new Date(log.timestamp).toLocaleString() }}</td>
            </tr>
          </tbody>
        </table>
        <button v-if="nextPage" class="button is-primary is-small" @click="fetchLogs(nextPage)">Load More</button>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { toast } from "bulma-toast";
  
  export default {
    name: 'AdminActivityLogs',
    data() {
      return {
        logs: [],
        nextPage: null,
        filters: {
          start_date: '',
          end_date: '',
          action: '',
          user: '',
        },
      };
    },
    methods: {
      async fetchLogs(url = null, append = true) {
        const apiUrl = url || '/api/v1/admin-activity-logs/';
        try {
          const response = await axios.get(apiUrl, {
            headers: { 'Authorization': `Token ${localStorage.getItem('token')}` },
            params: this.filters, // Apply filters
          });
          if (append) {
            this.logs = this.logs.concat(response.data.results);
          } else {
            this.logs = response.data.results;
          }
          this.nextPage = response.data.next;
        } catch (error) {
          console.error('Error fetching logs:', error);
          toast({
            message: "Failed to load logs. Please try again.",
            type: "is-danger",
            duration: 5000,
            position: "top-right",
          });
        }
      },
      applyFilters() {
        this.fetchLogs(null, false); // Fetch logs with updated filters
      },
      resetFilters() {
        this.filters = {
          start_date: '',
          end_date: '',
          action: '',
          user: '',
        };
        this.fetchLogs(null, false); // Refresh logs
      },
      async downloadCSV() {
        try {
          const response = await axios.get('/api/v1/admin-activity-logs/csv/', {
            headers: { 'Authorization': `Token ${localStorage.getItem('token')}` },
            params: this.filters,
            responseType: 'blob',
          });
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'admin_activity_logs.csv');
          document.body.appendChild(link);
          link.click();
          link.remove();
          toast({
            message: "CSV downloaded successfully.",
            type: "is-success",
            duration: 3000,
            position: "top-right",
          });
        } catch (error) {
          console.error('Error downloading CSV:', error);
          toast({
            message: "Failed to download CSV. Please try again.",
            type: "is-danger",
            duration: 5000,
            position: "top-right",
          });
        }
      },
    },
    async created() {
      await this.fetchLogs();
    },
  };
  </script>
  
  <style scoped>
  .filters {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;
  }
  </style>
  